export const permissions = {
  admin: {
    canCreate: true,
    canEdit: true,
    canDelete: true,
  },
  manager: {
    canCreate: true,
    canEdit: false,
    canDelete: false,
  },
  viewer: {
    canCreate: false,
    canEdit: false,
    canDelete: false,
  },
};
